const lengths = {
  name: 50,
  containerKey: 50,
  email: 50,
  metadataValue: 80,
  // The length of decimal.MaxValue in .NET
  number: 29,
};
export default lengths;
